import AddressWrapper from './AddressWrapper';

export default AddressWrapper;
